import * as React from "react";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { HamburgerMenu } from "../../../misc/components/HamburgerMenu";
import { Authorization } from "../../../misc/components/Authorization";
import { Link } from "react-router-dom";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../Core/SecurityContext";
import { StudyFixedCommentSet } from "webportalclient";

interface FixedCommentSetHamburgerMenuProps {
    set: StudyFixedCommentSet;
}

export const FixedCommentSetHamburgerMenu = ({ set }: FixedCommentSetHamburgerMenuProps): JSX.Element => {

    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    return (<HamburgerMenu>
        <Authorization permissionId={PermissionEnum.EditFixedComment}
            studyId={study.id}
            currentPermissions={currentUserPermissions}
        >
            <li>
                <Link to={`/FixedComments/Edit/${set.id}`}>Edit Set</Link>
            </li>
        </Authorization>
    </HamburgerMenu>);
};
